//SCROLL MAGIC
var controller = new ScrollMagic.Controller();
var tl = new TimelineMax();


//LOOK BOOK ARCHIVEページ　スライダー

if(document.querySelector('.archive-swiper-container')) {
   
var autoplay = 5000;
var swiperLookbookArchive = new Swiper('.archive-swiper-container', {
  autoplay: {
    delay: autoplay,
    disableOnInteraction: false,
  },
  effect: 'fade',
  fade: {
    crossFade: true
  },
  simulateTouch: true,
  watchSlidesProgress: true,
  loop: true,
  speed: 1250,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  on: {
    slideChange: function() {
      $(function() {
        $('div.swiper-num .current').text(swiperLookbookArchive.realIndex + 1);
        $('div.swiper-num .total').text(swiperLookbookArchive.slides.length - 2);
        if ($('#progress').length) {
          slide_progress();
        }
      });
    },
  },

});

function slide_progress() {
  var elem = document.getElementById("progress");
  var swiperWidth = 1;
  var count = 0;
  var end = 100;
  var interval = 4000;
  var autoplayTime = interval / 100;
  var id = setInterval(

    function() {
      count++;
      
        elem.style.width = count + '%';
        // 終了条件
     if ($('#progress').length) { }
      if (count == end) {
        clearInterval(id);
      }
    }, interval
  )
}

$(function() {
        if ($('#archive-collection-slider').length) {
          $("#archive-collection-slider").slick({
            arrows: false,
            autoplay: true,
            slidesToShow: 2.5,
            slidesToScroll: 1,
            autoplaySpeed: 0,
            speed: 8000,
            cssEase: "linear",
            pauseOnHover: true,
           responsive: [{
            breakpoint: 767,
            settings: {
              slidesToShow: 1.5,
            }
    	
   			 }]
          });
        }
  		 if ($('#archive-collection-wrapper').length) {
          $("#archive-collection-wrapper").each(function() {

            new ScrollMagic.Scene({
                triggerElement: this,
                //duration:400,
                reverse: true,
                triggerHook: 1
              })
              .addTo(controller)
              //.setPin('#archive-page-left')
              .setClassToggle("#archive-page-left", "fixed-off")
          });
      }

  });
  
}